import axios from "axios";
import { getField, updateField } from "vuex-map-fields";
import i18n from "@/i18n";

export default {
  namespaced: true,
  state: {
    storage_rack_shelf: {
      name: null,
      storage_id: null,
      rack_id: null,
    },
    storage_rack: {
      name: null,
      storage_id: null,
    },
    storage: {
      id: null,
      name: null,
    },
    fetched: false,
    savingInProgress: false,
    storages: [],
    nowUpdatingExportForStorageWithId: null,
    storageExportParams: {},
    storageExportParamsValues: {},
    isFetchedGoodsExportParameterValues: false
  },
  getters: {
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
    setStorageExportParamsValues(state, data) {
      state.storageExportParamsValues[data.export_name] = data.data;
      state.storageExportParamsValues = { ...state.storageExportParamsValues };
    },
    setStorageExportParams(state, data) {
      state.storageExportParams[data.export_name] = data.data;
      state.storageExportParams = { ...state.storageExportParams };
    },
    updateOneStorageInState(state, data) {
      let existsAtIndex = state.storages.findIndex((u) => u.id === data.id);
      if (existsAtIndex !== -1) {
        state.storages[existsAtIndex] = data;
      }
      //Clone the array to trigger a UI update
      state.storages = [...state.storages];
    },
  },
  actions: {
    async getGoodsExportParameterValues({ commit, state, dispatch }, payload) {
      updateField(state, {
        path: "isFetchedGoodsExportParameterValues",
        value: false,
      });
      return await axios
        .get(
          this._vm.$apiURL +
            "/storages/goods_export_parameters_values?export_name=" +
            payload.export_name
        )
        .then((response) => {
          commit("setStorageExportParamsValues", {
            data: response.data.data,
            export_name: payload.export_name,
          });
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, {
            path: "isFetchedGoodsExportParameterValues",
            value: true,
          });
        });
    },
    async setGoodsExportParameters({ commit, state, dispatch }, payload) {
      updateField(state, {
        path: "nowUpdatingExportForStorageWithId",
        value: payload.storage_id,
      });
      return await axios
        .put(
          this._vm.$apiURL +
            "/storages/" +
            payload.storage_id +
            "/goods_export_parameters/" +
            payload.export_name,
          payload
        )
        .then((response) => {
          commit("updateOneStorageInState", response.data.storage);
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, {
            path: "nowUpdatingExportForStorageWithId",
            value: false,
          });
        });
    },
    async getGoodsExportParameters({ commit, state, dispatch }, payload) {
      updateField(state, {
        path: "nowUpdatingExportForStorageWithId",
        value: payload.storage_id,
      });
      return await axios
        .get(
          this._vm.$apiURL +
            "/storages/" +
            payload.storage_id +
            "/goods_export_parameters/" +
            payload.export_name
        )
        .then((response) => {
          updateField(state, {
            path: "storageExportParams.export_name",
            value: response.data,
          });
          commit("setStorageExportParams", {
            data: response.data.data,
            export_name: payload.export_name,
          });
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, {
            path: "nowUpdatingExportForStorageWithId",
            value: false,
          });
        });
    },
    storage_save({ commit, state, dispatch }, payload) {
      updateField(state, { path: "savingInProgress", value: true });
      return axios[payload.id ? "put" : "post"](
        this._vm.$apiURL + "/storages" + (payload.id ? `/${payload.id}` : ""),
        payload
      )
        .then((response) => {
          this._vm.$inform(this._vm.i18n.t("common.operation_success"));
          return response.data.id;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "savingInProgress", value: false });
        });
    },
    rack_save({ commit, state, dispatch }, payload) {
      updateField(state, { path: "savingInProgress", value: true });
      return axios[payload.id ? "put" : "post"](
        this._vm.$apiURL +
          "/storage_racks" +
          (payload.id ? `/${payload.id}` : ""),
        payload
      )
        .then((response) => {
          this._vm.$inform(this._vm.i18n.t("common.operation_success"));
          return response.data.id;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "savingInProgress", value: false });
        });
    },
    shelf_save({ commit, state, dispatch }, payload) {
      updateField(state, { path: "savingInProgress", value: true });
      return axios[payload.id ? "put" : "post"](
        this._vm.$apiURL +
          "/storage_rack_shelves" +
          (payload.id ? `/${payload.id}` : ""),
        payload
      )
        .then((response) => {
          this._vm.$inform(this._vm.i18n.t("common.operation_success"));
          return response.data.id;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "savingInProgress", value: false });
        });
    },
    async shelf_remove({ commit, state, dispatch }, payload) {
      updateField(state, { path: "savingInProgress", value: false });
      return await this._vm
        .$confirm({
          title: this._vm.i18n.t("common.confirm"),
          text: this._vm.i18n.t("common.confirm_remove"),
          cancelText: this._vm.i18n.t("common.no"),
          acceptText: this._vm.i18n.t("common.yes"),
        })
        .then(async (y) => {
          return await axios
            .delete(this._vm.$apiURL + "/storage_rack_shelves/" + payload)
            .then((response) => {
              if (response.data.status === "success") {
                this._vm.$inform(this._vm.i18n.t("common.success_remove"));
                return true;
              }
            })
            .catch((error) => {
              dispatch("common/showError", { error: error }, { root: true });
            })
            .finally(() => {
              updateField(state, { path: "savingInProgress", value: false });
            });
        })
        .catch((n) => {})
        .finally(() => {
          updateField(state, { path: "savingInProgress", value: false });
        });
    },
    async rack_remove({ commit, state, dispatch }, payload) {
      updateField(state, { path: "savingInProgress", value: false });
      return await this._vm
        .$confirm({
          title: this._vm.i18n.t("common.confirm"),
          text: this._vm.i18n.t("common.confirm_remove"),
          cancelText: this._vm.i18n.t("common.no"),
          acceptText: this._vm.i18n.t("common.yes"),
        })
        .then(async (y) => {
          return await axios
            .delete(this._vm.$apiURL + "/storage_racks/" + payload)
            .then((response) => {
              if (response.data.status === "success") {
                this._vm.$inform(this._vm.i18n.t("common.success_remove"));
                return true;
              }
            })
            .catch((error) => {
              dispatch("common/showError", { error: error }, { root: true });
            })
            .finally(() => {
              updateField(state, { path: "savingInProgress", value: false });
            });
        })
        .catch((n) => {})
        .finally(() => {
          updateField(state, { path: "savingInProgress", value: false });
        });
    },
    async storage_remove({ commit, state, dispatch }, payload) {
      updateField(state, { path: "savingInProgress", value: false });
      return await this._vm
        .$confirm({
          title: this._vm.i18n.t("common.confirm"),
          text: this._vm.i18n.t("common.confirm_remove"),
          cancelText: this._vm.i18n.t("common.no"),
          acceptText: this._vm.i18n.t("common.yes"),
        })
        .then(async (y) => {
          return await axios
            .delete(this._vm.$apiURL + "/storages/" + payload)
            .then((response) => {
              if (response.data.status === "success") {
                this._vm.$inform(this._vm.i18n.t("common.success_remove"));
                return true;
              }
            })
            .catch((error) => {
              dispatch("common/showError", { error: error }, { root: true });
            })
            .finally(() => {
              updateField(state, { path: "savingInProgress", value: false });
            });
        })
        .catch((n) => {})
        .finally(() => {
          updateField(state, { path: "savingInProgress", value: false });
        });
    },
    async get({ commit, state, dispatch }) {
      updateField(state, { path: "fetched", value: false });
      return await axios
        .get(`${this._vm.$apiURL}/storages`)
        .then((response) => {
          updateField(state, { path: "storages", value: response.data });
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "fetched", value: true });
        });
    },
  }
};
